@if(authService.currentUserSubject | async; as user){
<div class="flex flex-col p-4">
  <span class="font-bold mb-2">{{ user.firstName }} {{ user.lastName }}</span>
  <span class="font-bold text-muted mb-2 text-sm">{{ user.email }}</span>
  <hr class="w-full !border-gray-400" />
  <div class="flex flex-col gap-3">
    <a
      class="!font-semibold !text-[#7E8299] !cursor-pointer"
      [routerLink]="['/user-details/', user.userId]"
      >{{"USER_INNER.ACCOUNT_SETTINGS" | translate}}</a
    >

    <div
      class="!font-semibold !text-[#7E8299] w-full flex items-center justify-between"
    >
      <span>{{"USER_INNER.CHANGE_LANGUAGE" | translate}}</span>
      <img
        class="cursor-pointer"
        (click)="translateService.toggleLanguage()"
        [src]="translateService.flagUrl()"
        height="15"
        width="15"
        alt=""
        srcset=""
      />
    </div>

    <a class="!font-semibold !text-[#7E8299] !cursor-pointer" (click)="logout()"
      >{{"USER_INNER.SIGN_OUT" | translate }}</a
    >
  </div>
</div>
}
